import React from 'react'
import gettingStarted from './gettingStarted.js'
import crew from './crew.js'
import employees from './employees.js'
import patientTransport from './patientTransport.js'
import commandControl from './commandControl.js'
import eventPlanning from './eventPlanning.js'
import finance from './finance.js'
import clinicalRecords from './clinicalRecords.js'
import governance from './governance.js'
import fleetEquipment from './fleetEquipment.js'
import { docsMDXComponents } from '../components/DocsMDXProvider.jsx'
import DocsLandingPage from '../components/DocsLandingPage.jsx'

export const docsSections = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    pages: gettingStarted,
  },
  {
    id: 'crew',
    title: 'For Crew & Staff',
    pages: crew,
  },
  {
    id: 'employees-hr',
    title: 'Employees & HR',
    groups: employees,
  },
  {
    id: 'event-planning',
    title: 'Event Planning',
    groups: eventPlanning,
  },
  {
    id: 'finance',
    title: 'Finance',
    groups: finance,
  },
  {
    id: 'clinical-records',
    title: 'Clinical Records',
    groups: clinicalRecords,
  },
  {
    id: 'clinical-governance',
    title: 'Clinical Governance',
    groups: governance,
  },
  {
    id: 'fleet-equipment',
    title: 'Fleet & Equipment',
    groups: fleetEquipment,
  },
  {
    id: 'command-control',
    title: 'Command & Control',
    groups: commandControl,
  },
  {
    id: 'patient-transport',
    title: 'Patient Transport',
    groups: patientTransport,
  },
]

export const getSectionPages = (section) => {
  // GROUPS
  if (section.groups?.length) {
    return section.groups.flatMap((group) => {
      // GROUP IS A PAGE
      if (group.component) {
        return [
          {
            ...group,
            groupId: group.id,
            groupTitle: group.title,
          },
        ]
      }

      // GROUP HAS PAGES
      return (group.pages || []).map((page) => ({
        ...page,
        groupId: group.id,
        groupTitle: group.title,
      }))
    })
  }

  // SECTION HAS DIRECT PAGES
  return section.pages || []
}

const pageRoutes = docsSections.flatMap((section) =>
  getSectionPages(section).map((page) => {
    const PageComponent = page.component

    return {
      path: `${section.id}/${page.id}`,
      element: <PageComponent components={docsMDXComponents} />,
      section,
      page,
    }
  }),
)

export const docRoutes = [
  {
    index: true,
    element: <DocsLandingPage />,
  },
  ...pageRoutes,
]
